import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "looks-copy" }
const _hoisted_3 = { class: "looks-bento home-stagger" }
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: "looks",
    "aria-label": _ctx.t('homeLooksTitle')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.t('homeLooksTitle')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (look, index) => {
        return (_openBlock(), _createElementBlock("figure", {
          key: look.titleKey,
          class: _normalizeClass(['tile', { featured: index === 0 }])
        }, [
          _createElementVNode("img", {
            src: look.src,
            alt: _ctx.t(look.titleKey)
          }, null, 8, _hoisted_4),
          _createElementVNode("figcaption", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t(look.titleKey)), 1)
          ])
        ], 2))
      }), 128))
    ])
  ], 8, _hoisted_1)), [
    [_directive_home_reveal]
  ])
}